import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import axe from '../../../services/axios-client/axiosClient';
import { generalAlertError, generalAlertSuccessToast } from '../../../common/utils/alerts';

function DocumentUploadComponent({
  document, threadId, setUploadedDocuments,
  uploadedDocuments,
}) {
  const [uploadingFile, setUploadingFile] = useState(false);

  const toBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

  const uploadDocumentForAiProduct = async (file) => {
    setUploadingFile(true);
    const base64 = await toBase64(file);
    const fileName = file.name;

    const data = {
      document_name: fileName,
      document_type: document.field,
      document_type_name: document.name,
      document: base64.replace('data:application/pdf;base64,', ''),
    };

    const response = await axe.post(`/documents/ai-upload/${threadId}`, data);

    if (response.status !== 200) {
      generalAlertError(response.data.error || 'Si è verificato un errore durante il caricamento del documento');
      setUploadingFile(false);
      return;
    }
    setUploadedDocuments((prev) => [...prev, response.data.data.document]);
    generalAlertSuccessToast('Documento caricato con successo');
    setUploadingFile(false);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      await uploadDocumentForAiProduct(file);
    }
  };

  return (
    <>
      {uploadedDocuments.find(((doc) => doc.document_type === document.field)) ? (
        <div className="col-12 col-md-6">
          <label htmlFor={document.field} className="form-label">
            <small>{`CARICATO ${uploadedDocuments.find(((doc) => doc.document_type === document.field)).document_type_name.toUpperCase()}`}</small>
          </label>
          <div className="card my-2 bg-success rounded-2">
            <div className="card-body p-0 bg-success rounded-2">
              <ul className="list-group bg-success rounded-2">
                <li className="list-group-item m-0 bg-success rounded-2 text-white d-flex align-items-center justify-content-between flex-wrap">
                  <p className="m-0 text-wrap">
                    <small>
                      {uploadedDocuments.find(((doc) => doc.document_type === document.field)).document_name}
                    </small>
                  </p>
                  <FontAwesomeIcon icon={faCheckCircle} color="white" className="ms-auto " size="lg" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-12 col-md-6">
          {uploadingFile ? (
            <div className="bg-success text-white bg-opacity-75 border px-3 py-2 rounded w-100 ms-auto my-2 d-flex align-items-center justify-content-center gap-2">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p
                className="m-0"
              >
                Caricando
                {' '}
                {document.name}
                ...
              </p>
            </div>
          ) : (
            <>
              <label htmlFor={document.field} className="form-label">{`CARICA ${document.name.toUpperCase()}`}</label>
              <input type="file" className="form-control w-100" onChange={handleFileChange} />
            </>
          )}

        </div>
      )}
    </>
  );
}

export default DocumentUploadComponent;
